import React, {useState, useEffect} from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';

export const TabComponent = (props) => {
  const {tabs, initialTab} = props;

  const [tabList, setTabList] = useState([]);
  const [activeTab, setActiveTab] = useState(
    initialTab ? initialTab : _.get(tabs, '0.id', 0)
  );

  useEffect(() => {
    const validTabs = tabs?.filter((tab) => tab.name) ?? [];

    setTabList(validTabs);
  }, [tabs]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    props.setActiveTab(tabId);
  };

  const renderCount = (count) => {
    return count || count === 0 ? <span>{` (${count})`}</span> : null;
  };

  const renderTabs = () => (
    <nav className="tab-container" aria-label="tabNavigation">
      {tabList.map(({id, name, count}) => (
        <ul key={id} role="tablist">
          <li className={`tab ${activeTab === id ? 'active' : ''}`}>
            <a
              aria-label={`${name}`}
              aria-controls={`tab-${id}`}
              key={id}
              href="#"
              onClick={() => handleTabClick(id)}
            >
              {name}
              {renderCount(count)}
            </a>
          </li>
        </ul>
      ))}
    </nav>
  );

  return <>{renderTabs()}</>;
};

export default connectDynamic(TabComponent);
